<template>
  <div class="row" style="min-width: 1200px; min-height: 100%; overflow: hidden !important;">

    <LightGallery :disable-scroll="true" :images="fullScreenImageArr" :index="imageIndex"
                  @close="fullScreenImageDialog=false" v-if="fullScreenImageDialog"></LightGallery>

    <q-dialog persistent position="right" v-model="makeTransferDialog">
      <stock-transfer :to_org-name="org.name" :to_orgId="org_id" :to_orgObj="selectedOrgObj"
                      @closeStockTransferDialog="selectedOrgObj='';makeTransferDialog=false"
                      ref="stock-transfer"></stock-transfer>
    </q-dialog>

    <q-dialog persistent position="right" v-model="InventoryItemsDialog">
      <inventory-items :orgId="org_id"
                       @closeInventoryItemsDialog="InventoryItemsDialog=false"></inventory-items>
    </q-dialog>

    <q-dialog persistent position="right" v-model="uploadFileDialog">
      <upload-file @closeUploadFileDialog="uploadFileDialog=false"
                   @fileResponseData="onReceiveFileResponse($event)"></upload-file>
    </q-dialog>

    <div class="card dialogBox">
      <!-- drawer -->
      <div id="q-app">
        <div class="p-0">
          <q-layout class="shadow-1 rounded-borders" container style="height: 100vh" view="hHh Lpr lff">
            <q-drawer :breakpoint="500"
                      :content-style="{ backgroundColor: '#3E4C4C' ,  color: '#fff' , boxShadow:'2px 0px 7px -2px #000' }"
                      :mini="miniState" :width="200" mini-to-overlay show-if-above
                      v-model="drawer">
              <q-scroll-area class="fit">
                <q-list padding>
                  <q-item @click="menuId=0" active clickable v-ripple>
                    <q-tooltip>
                      Basic Info
                    </q-tooltip>
                    <q-item-section avatar>
                      <i class="fas fa-user d-block" style="font-size: 18px"></i>
                    </q-item-section>
                    <q-item-section style="margin-left: -15px;">
                      Basic Info
                    </q-item-section>
                  </q-item>
                  <q-item @click="menuId=1" clickable v-ripple>
                    <q-tooltip>
                      Documentation
                    </q-tooltip>
                    <q-item-section avatar>
                      <q-icon><i class="fas fa-file-signature" style="font-size: 18px"></i>
                      </q-icon>
                    </q-item-section>

                    <q-item-section style="margin-left: -15px;">
                      Documentation
                    </q-item-section>
                  </q-item>

                  <q-item :active="menuId === 8" @click="menuId=8" active-class="my-menu-link" class="detail-side-menu"
                          clickable v-ripple>
                    <q-tooltip> Scheme</q-tooltip>
                    <q-item-section avatar>
                      <q-icon name="local_offer"></q-icon>
                    </q-item-section>
                    <q-item-section style="margin-left: -15px;">
                      Scheme
                    </q-item-section>
                  </q-item>

                </q-list>
              </q-scroll-area>
            </q-drawer>

            <q-page-container>
              <div v-if="menuId===0">
                <q-page padding>
                  <div class="dialogHeader position-relative ">
                    <div class="app-fixed-header w-100">
                      <div class="d-flex justify-content-between w-100"
                           style="align-items: center; height: 60px;">
                        <h4 style="font-size: 26px; font-weight: 300; margin-left: 80px; ">
                          Basic informations
                        </h4>

                        <div class="d-flex" style="justify-content: space-between">
                          <div @click="closeDialog" class="drawerButtons">
                            <q-btn flat icon="close" round size="small"></q-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row " style="margin-top: 50px;">
                    <div class="col-7 pr-2">
                      <div class="box p-4 position-relative">
                        <!--header-->
                        <div class="d-flex w-100 justify-content-between mb-3">
                          <div>
                            <h4 class="mb-2" style="font-size: 22px; line-height: 20px">
                              {{ org.name }}
                            </h4>
                            <span style="font-size: 16px; font-weight: 300">#{{
                                org.partnerCode
                                    ? org.partnerCode
                                    : '-'
                              }}</span>
                          </div>
                          <!--<div>-->
                          <!--<q-btn @click="makeTransferDialog=true" class="transferButton">-->
                          <!--<i class="fas fa-exchange-alt"></i>-->
                          <!--<q-tooltip>-->
                          <!--Stock transfer-->
                          <!--</q-tooltip>-->
                          <!--</q-btn>-->
                          <!--</div>-->
                        </div>
                        <!--content-->
                        <!--Company Details-->
                        <div class="partnerStatus">
                          <span class="px-2" style="font-size: 14px !important;">{{
                              org.PartnerType
                                  ? org.PartnerType.name
                                  : '-'
                            }}</span>
                        </div>

                        <div class="d-flex" style="margin-top: 50px;">
                          <div class="companyDetails p-1 py-3">
                            <ul style="list-style: none">
                              <li>
                                <div class="d-flex">
                                  <div class="d-icon">
                                    <span><i class="fas fa-phone-alt icons"></i></span>
                                  </div>
                                  <div class="ml-3 d-details">
                                    <span>{{ org.mobile ? org.mobile : '-' }}</span>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div class="d-flex">
                                  <div class="d-icon">
                                    <span><i class="fas fa-phone-alt icons"></i></span>
                                  </div>
                                  <div class="ml-3 d-details">
                                    <span>{{ org.alternateNumber ? org.alternateNumber : '-' }}</span>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div class="d-flex">
                                  <div class="d-icon">
                                    <span><i class="fas fa-envelope icons"></i></span>
                                  </div>

                                  <div class="ml-3 d-details">
                                    <span>{{ org.email ? toLower(org.email) : '-' }}</span>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div class="d-flex">
                                  <div class="d-icon">
                                    <span><i class="fas fa-map-marker-alt icons"></i></span>
                                  </div>

                                  <div class="ml-3 d-details">
                                    <span v-if="org.address">
                                      {{ org.address.add1|titleize }},<br/>
                                      <template v-if="org.address.add2">{{ org.address.add2|titleize }},<br/></template>
                                        {{ org.address.area|titleize }}, {{ org.address.city|titleize }},<br/>
                                        {{ org.address.state|titleize }} - {{ org.address.pin|titleize }},
                                      {{ org.address.country|titleize }}
                                    </span>
                                    <span v-else>-</span>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div class="d-flex">
                                  <div class="d-icon">
                                    <span><i class="fas fa-calendar-alt icons"></i></span>
                                  </div>
                                  <div class="ml-3 d-details">
                                    <span v-if="org.incorporateDate">{{ org.incorporateDate| dateFilter }}</span>
                                    <span v-else>-</span>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>

                          <!--Owner Details-->

                          <div class="ownerSlider">
                            <q-carousel :navigation="users.length>1" animated class=""
                                        control-color="primary" height="auto" padding
                                        ref="carousel" swipeable transition-next="scale"
                                        transition-prev="scale" v-model="slide">
                              <q-carousel-slide :key="index"
                                                class="column no-wrap flex-center"
                                                name="style"
                                                v-for="(user,index) in users">
                                <ul style="list-style: none">
                                  <li>
                                    <div class="d-flex">
                                      <div class="d-icon"
                                           style="width: 40px; height: 40px;">
                                        <img alt=""
                                             class="w-100"
                                             src="../../assets/user1.png">
                                        <!--<div class="user">-->
                                        <!--<i class="fas fa-user icons"-->
                                        <!--style="font-size: 18px;"></i>-->
                                        <!--</div>-->
                                      </div>

                                      <div class="ml-3 d-details">
                                        <span style="display: block">{{ user.name ? user.name : '-' }}</span>

                                        <span style="font-size: 14px; font-weight: 300">{{
                                            user.UserType
                                                ? user.UserType.name
                                                : '-'
                                          }}</span>
                                      </div>
                                    </div>
                                  </li>
                                  <li>
                                    <div class="d-flex">
                                      <div class="d-icon">
                                        <span><i class="fas fa-phone-alt icons"></i></span>
                                      </div>
                                      <div class="ml-3 d-details">
                                        <span>{{ user.mobile ? user.mobile : '-' }}</span>
                                      </div>
                                    </div>
                                  </li>
                                  <li>
                                    <div class="d-flex">
                                      <div class="d-icon">
                                                                                <span><i
                                                                                    class="fas fa-envelope icons"></i></span>
                                      </div>

                                      <div class="ml-3 d-details">
                                        <span>{{ user.email ? toLower(user.email) : '-' }}</span>
                                      </div>
                                    </div>
                                  </li>
                                  <li>
                                    <div class="d-flex">
                                      <div class="d-icon">
                                        <span><i class="fas fa-birthday-cake icons"></i></span>
                                      </div>
                                      <div class="ml-3 d-details">
                                        <span>{{ user.birthdate| dateFilter }}</span>
                                      </div>
                                    </div>
                                  </li>
                                  <li>
                                    <div class="d-flex">
                                      <div class="d-icon">
                                        <span><i class="fas fa-heart icons"></i></span>
                                      </div>

                                      <div class="ml-3 d-details">
                                        <span>{{ user.aniversary| dateFilter }}</span>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </q-carousel-slide>
                              <!--<q-carousel-slide name="tv" class="column no-wrap flex-center">-->

                              <!--</q-carousel-slide>-->
                              <template v-if="users.length>1" v-slot:control>
                                <q-carousel-control :offset="[18, 18]" class="q-gutter-xs" position="bottom-right">
                                  <q-btn @click="$refs.carousel.previous()" dense icon="arrow_left" outline round
                                         style="color: gray !important;"></q-btn>
                                  <q-btn @click="$refs.carousel.next()" dense icon="arrow_right" outline
                                         round style="color: gray !important;"></q-btn>
                                </q-carousel-control>
                              </template>
                            </q-carousel>
                          </div>


                        </div>


                      </div>
                    </div>

                    <!--Stock-->
                    <div class="col-5 pl-2">
                      <div class="box p-4 pt-3 ">
                        <div class="p-1 pt-0 mb-4" style="text-align: center">
                          <div class="d-flex justify-content-between">
                            <q-btn @click="transferStock(org)" class="mt-2"
                                   outline
                                   style="border: 1px solid #105992; color: #105992; width: auto; ">
                              Transfer Stock
                              <!--<i class="fas fa-exchange-alt"></i>-->
                              <q-tooltip>
                                Transfer Stock
                              </q-tooltip>
                            </q-btn>
                            <q-btn @click="InventoryItemsDialog=true" class="mt-2"
                                   outline
                                   style="border: 1px solid #105992; color: #105992; width: auto; ">
                              View Details
                            </q-btn>
                          </div>
                        </div>

                        <div class="p-1" style="text-align: center;">
                          <div>
                            <h3 class="mt-3"
                                style="font-weight: 300; text-align: center; color:#3e4c4c; font-size: 56px">
                              {{ counts.productLine }}
                            </h3>
                          </div>

                          <div>
                                                        <span class="d-block mb-3 ml-3 mt-auto"
                                                              style="font-size: 16px; text-align: center">Product Lines</span>
                          </div>
                        </div>
                        <hr style="border: 1px solid lightgray !important; opacity: 0.3">

                        <div class="p-1" style="text-align: center">

                          <h3 class="mt-3"
                              style="font-weight: 300; text-align: center; color:#3e4c4c; font-size: 56px">
                            {{ counts.product }}</h3>
                          <span class="d-block mb-3"
                                style="font-size: 16px; text-align: center">Product</span>

                        </div>
                        <hr style="border: 1px solid lightgray !important; opacity: 0.3">

                        <div class="p-1" style="text-align: center;">
                          <h3 class="mt-3"
                              style="font-weight: 300; text-align: center; color:#3e4c4c; font-size: 56px">
                            {{ counts.inventory }}</h3>
                          <span class="d-block mb-3"
                                style="font-size: 16px; text-align: center">Inventory</span>

                        </div>

                      </div>
                    </div>


                  </div>

                  <div class="row mb-5 pb-3">

                    <!--Sales Person-->

                    <div class="col-7 pt-3 pr-2">
                      <div class="col-12">
                        <div class="preffer-box p-3 mb-3 d-block" style="background: #fff;">
                          <div class="w-100 mb-3">
                            <h5 class="mb-2" style="font-size: 18px; line-height: 20px">
                              Sales Executive</h5>
                          </div>
                          <div class="d-flex " style="background: #fff;"
                               v-for="sp in org.SalesPersons">
                            <div class="preffer-icon my-auto">
                              <img alt="" class="w-100" src="../../assets/user1.png">
                            </div>
                            <div class="preffer-info">
                              <ul style="list-style: none">
                                <li>
                                  <div>
                                    <h6 class="mb-2"
                                        style="font-weight: 400; text-transform: capitalize">
                                      <div class="d-details d-flex">
                                        <span style="display: block; text-align: center;">{{
                                            sp.SalesPerson.name
                                                ? sp.SalesPerson.name
                                                : '-'
                                          }}</span>
                                      </div>
                                    </h6>
                                  </div>
                                </li>
                                <li>
                                  <div class="d-flex">
                                    <div class="p-icon">
                                      <i class="material-icons">local_phone</i>
                                    </div>
                                    <div class="p-text">
                                      <span>{{ sp.SalesPerson.mobile ? sp.SalesPerson.mobile : '-' }}</span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div class="d-flex">
                                    <div class="p-icon">
                                      <i class="material-icons">email</i>
                                    </div>
                                    <div class="p-text">
                                      {{ sp.SalesPerson.email ? (toLower(sp.SalesPerson.email)) : '-' }}
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div class="d-flex " style="background: #fff;"
                               v-if="org.SalesPersons && org.SalesPersons.length==0">
                            <div class="preffer-icon my-auto">
                              <img alt="" class="w-100" src="../../assets/user1.png">
                            </div>
                            <div class="preffer-info">
                              <ul>
                                <!--<img alt="" src="../../../src/assets/error.png" style="width: 100%">-->
                                <span
                                    style="font-size: 16px; text-align: center; display: block">No Sales Executive</span>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="preffer-box mb-3 p-3 d-block" style="background: #fff;">
                          <div class="w-100 mb-1">
                            <h5 class="mb-2" style="font-size: 18px; line-height: 20px">
                              Referral VAP</h5>
                          </div>
                          <div class="d-flex">
                            <div class="preffer-icon my-auto">
                              <img alt="" class="w-100" src="../../assets/user2.png">
                            </div>
                            <div class="preffer-info">
                              <ul style="list-style: none" v-if="org.ParentPartner">
                                <li>
                                  <div>
                                    <h6 class="mb-2"
                                        style="font-weight: 400; text-transform: capitalize">
                                      <div class="d-details d-flex">
                                        <span style="display: block; text-align: center;">{{
                                            org.ParentPartner
                                                ? org.ParentPartner.name
                                                : '-'
                                          }}</span>
                                        <span class="ml-2"
                                              style="font-size: 14px; display: block; text-align: center; font-weight: 300">( {{
                                            org.ParentPartner
                                                ? org.ParentPartner.partnerCode
                                                : '-'
                                          }} )</span>
                                      </div>
                                    </h6>
                                  </div>
                                </li>
                                <li>
                                  <div class="d-flex">
                                    <div class="p-icon">
                                      <i class="material-icons">local_phone</i>
                                    </div>
                                    <div class="p-text">
                                      <span>{{ org.ParentPartner ? org.ParentPartner.mobile : '-' }}</span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div class="d-flex">
                                    <div class="p-icon">
                                      <i class="material-icons">email</i>
                                    </div>
                                    <div class="p-text">
                                      {{ org.ParentPartner ? toLower(org.ParentPartner.email) : '-' }}
                                    </div>
                                  </div>
                                </li>
                              </ul>
                              <ul v-else>
                                <!--<img alt="" src="../../../src/assets/error.png" style="width: 100%">-->
                                <span style="font-size: 16px; text-align: center; display: block">No Referred By</span>
                              </ul>
                            </div>
                            <!--                                                    <div class="preffer-person text-right w-100">-->
                            <!--                                                        Referred VAP-->
                            <!--                                                    </div>-->
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="preffer-box p-3 d-block" style="background: #fff;">
                          <div class="w-100 mb-3">
                            <h5 class="mb-2" style="font-size: 18px; line-height: 20px">
                              Preferred Distributors for Purchase</h5>
                          </div>
                          <div class="d-flex " style="background: #fff;"
                               v-for="distributor in preferredDistributorsList">
                            <div class="preffer-icon my-auto">
                              <img alt="" class="w-100" src="../../assets/user3.png">
                            </div>
                            <div class="preffer-info">
                              <ul style="list-style: none">
                                <li>
                                  <div>
                                    <h6 class="mb-2"
                                        style="font-weight: 400; text-transform: capitalize">
                                      <div class="d-details d-flex">
                                        <span style="display: block; text-align: center;">{{
                                            distributor.PrefferedPartner.name
                                                ? distributor.PrefferedPartner.name
                                                : '-'
                                          }}</span>
                                        <span class="ml-2"
                                              style="font-size: 14px; display: block; text-align: center; font-weight: 300">( {{
                                            distributor.PrefferedPartner.partnerCode
                                                ? distributor.PrefferedPartner.partnerCode
                                                : '-'
                                          }} )</span>
                                      </div>
                                    </h6>
                                  </div>
                                </li>
                                <li>
                                  <div class="d-flex">
                                    <div class="p-icon">
                                      <i class="material-icons">local_phone</i>
                                    </div>
                                    <div class="p-text">
                                      <span>{{
                                          distributor.PrefferedPartner.mobile
                                              ? distributor.PrefferedPartner.mobile
                                              : '-'
                                        }}</span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div class="d-flex">
                                    <div class="p-icon">
                                      <i class="material-icons">email</i>
                                    </div>
                                    <div class="p-text">
                                      {{
                                        distributor.PrefferedPartner.email
                                            ? toLower(distributor.PrefferedPartner.email)
                                            : '-'
                                      }}
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div class="d-flex " style="background: #fff;"
                               v-if="preferredDistributorsList.length===0">
                            <div class="preffer-icon my-auto">
                              <img alt="" class="w-100" src="../../assets/user3.png">
                            </div>
                            <div class="preffer-info">
                              <ul>
                                <!--<img alt="" src="../../../src/assets/error.png" style="width: 100%">-->
                                <span style="font-size: 16px; text-align: center; display: block">No Preferred Distributor</span>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>


                    <!--Bank Details-->
                    <div class="col-5 pt-3 pl-2">
                      <div class="box position-relative p-4 bankDetails overflow-hidden"
                           v-for="bank in org.bankDetails">
                        <ul style="list-style: none">
                          <li>
                            <div class="bankLabel">
                              <label for="">Bank Name</label>
                            </div>
                            <div class="acInfo">
                              <span>{{ bank.bankName ? bank.bankName : '-' }}</span>
                            </div>
                          </li>
                          <li>
                            <div class="bankLabel">
                              <label for="">IFSC</label>
                            </div>
                            <div class="acInfo">
                              <span>{{ bank.ifsc ? bank.ifsc : '-' }}</span>
                            </div>
                          </li>
                          <li>
                            <div class="bankLabel">
                              <label for="">A/C No</label>
                            </div>
                            <div class="acInfo">
                              <span>{{ bank.accountNumber ? bank.accountNumber : '-' }}</span>
                            </div>
                          </li>
                          <li>
                            <div class="bankLabel">
                              <label for="">A/C Name</label>
                            </div>
                            <div class="acInfo">
                              <span>{{ bank.accountName ? bank.accountName : '-' }}</span>
                            </div>
                          </li>
                          <li class="d-flex justify-content-between">
                            <div>
                              <div class="bankLabel">
                                <label for="">Branch</label>
                              </div>
                              <div class="acInfo">
                                <span>{{ bank.branch ? bank.branch : '-' }}</span>
                              </div>
                            </div>

                            <div style="width: 50%;">
                              <div class="bankLabel">
                                <label for="">PAN</label>
                              </div>
                              <div class="acInfo">
                                <span>{{ org.PAN ? org.PAN : '-' }}</span>
                              </div>
                            </div>
                          </li>
                          <li class="d-flex justify-content-between">
                            <div>
                              <div class="bankLabel">
                                <label for="">A/C Type</label>
                              </div>
                              <div class="acInfo">
                                <span>{{ bank.acountType ? bank.acountType : '-' }}</span>
                              </div>
                            </div>

                            <div style="width: 50%;" v-if="org.partnerType === Constants.RP">
                              <div class="bankLabel">
                                <label for="">Aadhaar</label>
                              </div>
                              <div class="acInfo">
                                <span>{{ org.aadhaarNumber }}</span>
                              </div>
                            </div>
                            <div style="width: 50%;" v-else>
                              <div class="bankLabel">
                                <label for="">GSTIN</label>
                              </div>
                              <div class="acInfo">
                                <span>{{ org.gstin }}</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <div class="position-absolute" style="top: 10%; right: -10%">
                          <img alt="" src="../../../src/assets/card.png">
                        </div>
                      </div>
                    </div>
                  </div>
                </q-page>
              </div>
              <div v-if="menuId===1">
                <q-page padding>

                  <div class="dialogHeader position-relative ">
                    <div class="app-fixed-header w-100">
                      <div class="d-flex justify-content-between w-100"
                           style="align-items: center; height: 60px;">
                        <h4 style="font-size: 26px; font-weight: 300; margin-left: 80px; ">
                          Documentation
                        </h4>

                        <div class="d-flex" style="justify-content: space-between">

                          <div @click="closeDialog" class="drawerButtons">
                            <q-btn flat icon="close" round size="small"></q-btn>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-5 pb-3 " style="margin-top: 50px;">
                    <div class="col-6 q-pa-md pt-0 pl-0">
                      <div class="document-box px-3 box">
                        <i @click="fileToUpload='file-PAN';uploadFileDialog=true"
                           class="fas fa-edit" v-if="!org.documents || !org.documents.doc1.url"
                           style="float: right;margin-top: 12px;cursor: pointer;"></i>
                        <h4 style="font-size: 16px; font-weight: 300; ">
                          PAN Card
                        </h4>
                        <div class="document position-relative"
                             v-if="org.documents && org.documents.doc1.url && org.documents.doc1.url.split('.').pop() === 'pdf'">
                          <img alt="" class="w-100" src="../../../src/assets/downloadPDF.png">
                          <a :href="org.documents.doc1.url"
                             class="download-pdf position-absolute" target="_blank">DOWNLOAD</a>
                        </div>
                        <div @click="viewRoomImage(org.documents, 'doc1')"
                             class="document"
                             v-else-if="org.documents && org.documents.doc1.url">
                          <img :src="org.documents.doc1.url" alt=""
                               class="d-block mx-auto w-100">
                        </div>
                        <div v-else>
                          <img alt="" class="w-100" src="../../../src/assets/pancard.png">
                        </div>
                      </div>
                    </div>
                    <div class="col-6 pt-0 q-pa-md pr-0" v-if="org.partnerType !== Constants.RP">
                      <div class="px-3 document-box box">
                        <i @click="fileToUpload='file-GSTIN';uploadFileDialog=true"
                           class="fas fa-edit" v-if="!org.documents || !org.documents.doc2.url"
                           style="float: right;margin-top: 12px;cursor: pointer"></i>
                        <h4 style="font-size: 16px; font-weight: 300; ">GSTIN</h4>
                        <div class="document position-relative"
                             v-if="org.documents && org.documents.doc2.url && org.documents.doc2.url.split('.').pop() === 'pdf'">
                          <img alt="" class="w-100" src="../../../src/assets/downloadPDF.png">
                          <a :href="org.documents.doc2.url"
                             class="download-pdf position-absolute" target="_blank">DOWNLOAD</a>
                        </div>
                        <div @click="viewRoomImage(org.documents, 'doc2')" class="document"
                             v-if="org.documents && org.documents.doc2.url">
                          <img :src="org.documents.doc2.url" alt=""
                               class="d-block mx-auto w-100">

                        </div>
                        <div v-else>
                          <img alt="" class="w-100" src="../../../src/assets/gstin.png">
                        </div>
                      </div>
                    </div>
                    <div class="col-6 pt-0 q-pa-md pr-0" v-if="org.partnerType === Constants.RP">
                      <div class="px-3 document-box box">
                        <i @click="fileToUpload='aadhaarFront';uploadFileDialog=true"
                           class="fas fa-edit" v-if="!org.documents || !org.documents.aadhaarFront.url"
                           style="float: right;margin-top: 12px;cursor: pointer"></i>
                        <h4 style="font-size: 16px; font-weight: 300; ">Aadhaar Front</h4>
                        <div class="document position-relative"
                             v-if="org.documents && org.documents.aadhaarFront.url && org.documents.aadhaarFront.url.split('.').pop() === 'pdf'">
                          <img alt="" class="w-100" src="../../../src/assets/downloadPDF.png">
                          <a :href="org.documents.aadhaarFront.url"
                             class="download-pdf position-absolute" target="_blank">DOWNLOAD</a>
                        </div>
                        <div @click="viewRoomImage(org.documents, 'aadhaarFront')" class="document"
                             v-if="org.documents && org.documents.aadhaarFront.url">
                          <img :src="org.documents.aadhaarFront.url" alt=""
                               class="d-block mx-auto w-100">

                        </div>
                        <div v-else>
                          <img alt="" class="w-100" src="../../../src/assets/no_Data.png">
                        </div>
                      </div>
                    </div>
                    <div class="col-6 pt-0 q-pa-md pr-0" v-if="org.partnerType === Constants.RP">
                      <div class="px-3 document-box box">
                        <i @click="fileToUpload='aadhaarBack';uploadFileDialog=true"
                           class="fas fa-edit" v-if="!org.documents || !org.documents.aadhaarBack.url"
                           style="float: right;margin-top: 12px;cursor: pointer"></i>
                        <h4 style="font-size: 16px; font-weight: 300; ">Aadhaar Back</h4>
                        <div class="document position-relative"
                             v-if="org.documents && org.documents.aadhaarBack.url && org.documents.aadhaarBack.url.split('.').pop() === 'pdf'">
                          <img alt="" class="w-100" src="../../../src/assets/downloadPDF.png">
                          <a :href="org.documents.aadhaarBack.url"
                             class="download-pdf position-absolute" target="_blank">DOWNLOAD</a>
                        </div>
                        <div @click="viewRoomImage(org.documents, 'aadhaarBack')" class="document"
                             v-if="org.documents && org.documents.aadhaarBack.url">
                          <img :src="org.documents.aadhaarBack.url" alt=""
                               class="d-block mx-auto w-100">

                        </div>
                        <div v-else>
                          <img alt="" class="w-100" src="../../../src/assets/no_Data.png">
                        </div>
                      </div>
                    </div>
                  </div>


                </q-page>
              </div>
              <div v-if="menuId===8">
                <div class="dialogHeader position-relative ">
                  <div class="app-fixed-header w-100">
                    <div class="d-flex justify-content-between w-100"
                         style="align-items: center; height: 60px;">
                      <h4 style="font-size: 26px; font-weight: 300; margin-left: 80px; ">
                        Schemes
                      </h4>
                      <div class="d-flex" style="justify-content: space-between">
                        <div @click="closeDialog" class="drawerButtons">
                          <q-btn flat icon="close" round size="small"></q-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <PSchemes :current-partner="currentPartner" style="margin-top: 30px;"/>
              </div>
            </q-page-container>
          </q-layout>
        </div>
      </div>
      <!-- content -->

      <!--     <div class="text-h6" style="text-align: left">Users
           </div>
           <template v-if="users">
               <div class="row" v-for="user in users">
                   <div class="col-6" style="line-height: 200%">
                       <div style="margin-bottom: 15px">Name<br/><span>{{user.name}}</span></div>
                   </div>
                   <div class="col-6" style="line-height: 200%">
                       <div style="margin-bottom: 15px">Email<br/><span>{{user.email}}</span></div>
                   </div>
                   <div class="col-6" style="line-height: 200%">
                       <div style="margin-bottom: 15px">Mobile<br/><span>{{user.mobile}}</span></div>
                   </div>
               </div>
           </template>     -->
      <div v-show="!preferredDistributorsList.length">
        <q-inner-loading :showing="true" style="top: 183px">
          <q-spinner-dots size="50px" style="color: #027be3"/>
        </q-inner-loading>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_COUNTS, GET_ORG_BY_ID } from '../../graphql/queries/organization'
import { SUBSCRIBE_ORG_BY_ID } from '../../graphql/subscription/organization'
import { GET_PREFERRED_DISTRIBUTORS_FOR_RD } from '../../graphql/queries/Users'
import { GET_INVENTORY_BY_BATCH, GET_PRODUCTS_FROM_BATCH } from '../../graphql/queries/products'
import { INSERT_ORDER_ITEMS, INSERT_ORDERS } from '../../graphql/mutations/products'
import { UPDATE_ORGANIZATION_DOCUMENTS } from '../../graphql/mutations/organizations'
import StockTransfer from '../StockTransfer'
import moment from 'moment'
import { LightGallery } from 'vue-light-gallery'
import InventoryItems from '../InventoryItems'
import PSchemes from '../Partner/P-Schemes'
import UploadFile from '../UploadFile'
import Constants from '../../Constants/Constant'

export default {
  name: 'OrganizationDetail',
  components: { PSchemes, StockTransfer, LightGallery, InventoryItems, UploadFile },
  props: ['org_id', 'currentPartner', 'menu_id'],
  apollo: {
    Inventory: {
      query: GET_COUNTS,
      fetchPolicy: 'network-only',
      variables () {return { ownedBy: this.org_id }},
      result ({ data, loading }) {
        if (!loading) {
          this.counts.product = data.Product.aggregate.count

          this.counts.inventory = data.Inventory.aggregate.count
          var counts = []
          for (var i = 0; i < data.ProductLine.length; i++) {
            if (data.ProductLine[i].Product) {
              counts.push(data.ProductLine[i].Product.productLineId)
            }
          }

          this.counts.productLine = counts.length
        }
      },
    },
    Organizations: {
      query: GET_ORG_BY_ID,
      fetchPolicy: 'network-only',
      variables () {return { id: this.org_id }},
      subscribeToMore: {
        document: SUBSCRIBE_ORG_BY_ID,
        variables () {
          return { id: this.org_id }
        },
        updateQuery: function (previousQueryResult, { subscriptionData }) {
          this.preferredDistributorsList = []
          this.org = subscriptionData.data.Organizations.length ? subscriptionData.data.Organizations[0] : null
          if (this.org.PreferredDistributors && this.org.PreferredDistributors.length) {
            this.preferredDistributorsList = JSON.parse(JSON.stringify(this.org.PreferredDistributors))
          } else {
            this.fetchAIPL()
          }
        },
      },
      result ({ data, loading }) {
        if (!loading) {
          this.preferredDistributorsList = []
          this.users = data.Users.length ? data.Users : null
          this.org = data.Organizations.length ? data.Organizations[0] : null
          if (this.org.PreferredDistributors && this.org.PreferredDistributors.length) {
            this.preferredDistributorsList = JSON.parse(JSON.stringify(this.org.PreferredDistributors))
          } else {
            this.fetchAIPL()
          }
        }
      },
    },
    BatchTable: {
      query: GET_INVENTORY_BY_BATCH,
      fetchPolicy: 'network-only',
      variables () {
        return {
          ownedBy: this.user.orgId,
          batchFilter: this.batchFilter,
          status: 'InStock',
        }
      },
      result ({ data, loading }) {
        if (!loading) {
          this.batchArr = data.BatchTable
          this.$forceUpdate()
        }
      },
    },
  },
  computed: {
    invoiceDateComp () {return moment(this.invoiceDate).format('DD/MM/YYYY')},
  },
  methods: {
    async fetchAIPL () {
      this.preferredDistributorsList = []
      let response = await this.$apollo.query({
        fetchPolicy: 'network-only',
        query: GET_PREFERRED_DISTRIBUTORS_FOR_RD,
      })
      this.preferredDistributorsList = [{ PrefferedPartner: null }]
      this.preferredDistributorsList[0].PrefferedPartner = response.data.preferredDistributorsForRD[0]
    },
    cancelAddOrder () {
      this.makeTransferDialog = false
      this.groupOneSelection = []
      this.groupTwoSelection = []
    },
    closeDialog () {
      this.$emit('closeDialog', true)
    },
    addToCart () {
      this.groupTwoSelection = this.groupOneSelection
    },
    async addOrder () {
      // add order
      let self = this
      let batches
      if (this.transferType === 'manual') {
        batches = this.groupTwoSelection ? this.groupTwoSelection.length : 0
        //check empty
        if (batches == 0) {
          this.$q.notify('Please Enter/Select atleast one batch item.')
        } else {
          let orderRequest = {
            id: this.generateUUID(),
            date: moment().format(),
            from: self.user.orgId,
            to: self.org.id,
            lineItemCounts: batches,
            status: 'InTransit',
            placedBy: self.user.id,
            notes: '',
            invoiceNumber: self.invoiceNumber,
            invoiceNote: self.invoiceNote,
            invoiceDate: self.invoiceDate,
          }
          let response = await this.$apollo.mutate({
            mutation: INSERT_ORDERS,
            variables: orderRequest,
          }).then(res => {
            console.log(res)
            self.addOrderItems(orderRequest)
          }).catch(err => {
            console.log(err)
          })
        }
      } else if (this.transferType === 'bulk') {
        batches = this.transferData.split('\n').length
        //get data from bulk entries
        this.groupOneSelection = this.transferData.split('\n')
        // this.groupOneSelection = []
        let response = await this.$apollo.query({
          query: GET_PRODUCTS_FROM_BATCH,
          variables: { batches: this.groupOneSelection },
        })
        this.groupOneSelection = response.data.BatchTable
        let self = this
        if (batches == 0) {
          this.$q.notify('Please Enter/Select atleast one batch item.')
        } else {
          let orderRequest = {
            id: this.generateUUID(),
            date: moment().format('YYYY-MM-DD'),
            from: self.user.orgId,
            to: self.org.id,
            lineItemCounts: batches,
            status: 'InTransit',
            placedBy: self.user.id,
            notes: '',
            invoiceNumber: self.invoiceNumber,
            invoiceNote: self.invoiceNote,
            invoiceDate: self.invoiceDate,
          }
          let response = await this.$apollo.mutate({
            mutation: INSERT_ORDERS,
            variables: orderRequest,
          }).then(res => {
            console.log(res)
            self.addOrderItems(orderRequest)
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    addOrderItems (orderRequest) {
      // add order items
      let self = this
      let orderItemRequest
      self.groupOneSelection.forEach(inv => {
        orderItemRequest = {
          id: self.generateUUID(),
          orderId: orderRequest.id,
          qty: orderRequest.lineItemCounts,
          from: self.user.orgId,
          to: self.org.id,
          notes: '',
          sellType: '1',
          batchId: inv.id,
          productInventoryId: self.org.id,
          productId: inv.productId,
          status: 'InTransit',
        }
        let response = this.$apollo.mutate({
          mutation: INSERT_ORDER_ITEMS,
          variables: orderItemRequest,
        }).then(res => {
          console.log(res)
          // self.updateProductInventory(sameSerials)
        }).catch(err => {
          console.log(err)
        })
      })
      this.groupOneSelection = []
      this.groupTwoSelection = []
      this.$q.notify('Batch Transfer Successfully')
      this.makeTransferDialog = false
    },
    searchBatch (val, update, abort) {
      let splitted = val.split(' ')
      if (splitted.length <= 1) {
        if (val.length < 1) {
          abort()
          return
        }
        update(() => {
          this.batchFilter = '%' + val + '%'
        })
      }
    },
    generateUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    removeGroupOneSelection (batch) {
      var index = this.groupOneSelection.findIndex(function (item) {
        return item.id === batch.id
      })
      if (index > -1)
        this.groupOneSelection.splice(index, 1)
    },
    onReceiveFileResponse (fileResponse) {
      this.uploadFileDialog = false

      switch (this.fileToUpload) {
        case 'file-PAN':
          this.updateOrganizationDocuments(fileResponse, 'doc1')
          break
        case 'file-GSTIN':
          this.updateOrganizationDocuments(fileResponse, 'doc2')
          break
        case 'aadhaarFront':
          this.updateOrganizationDocuments(fileResponse, 'aadhaarFront')
          break
        case 'aadhaarBack':
          this.updateOrganizationDocuments(fileResponse, 'aadhaarBack')
          break
        default:
          // code block
      }
    },
    async updateOrganizationDocuments (fileResponse, fileAttribute) {
      if (!this.org.documents) {
        this.org.documents = {
          doc1: { url: '', path: '' },
          doc2: { url: '', path: '' },
          cheque1: { url: '', path: '' },
          cheque2: { url: '', path: '' },
          aadhaarFront: { url: '', path: '' },
          aadhaarBack: { url: '', path: '' },
        }
      }

      this.org.documents[fileAttribute] = {
        url: fileResponse.url,
        path: fileResponse.path,
        uploadedBy: this.user.id,
      }

      let request = {
        orgId: this.org.id,
        documents: this.org.documents,
      }
      let response = await this.$apollo.mutate({
        mutation: UPDATE_ORGANIZATION_DOCUMENTS,
        variables: request,
      })
      if (response.data) {
        this.$q.notify('Document Updated successfully')
      }
    },

    viewRoomImage (documentObj, docName) {
      var self = this
      this.fullScreenImageArr = []
      Object.keys(documentObj).forEach(function (curnt) {
        if (documentObj[curnt].url && curnt !== 'cheque1' && curnt !== 'cheque2') {
          self.fullScreenImageArr.push({ url: documentObj[curnt].url, title: curnt })
        }
      })
      this.imageIndex = this.fullScreenImageArr.findIndex((obj) => obj.title === docName)
      this.fullScreenImageDialog = true
    },
    transferStock (orgObj) {
      this.selectedOrgObj = orgObj
      this.makeTransferDialog = true
    },
  },
  data () {
    return {
      Constants: Constants,
      moment: moment,
      user: JSON.parse(localStorage.getItem('user')),
      org: {},
      inventory: { productLines: 0, products: 0, inventories: 0 },
      users: [],
      drawer: true,
      miniState: true,
      user: JSON.parse(localStorage.getItem('user')),
      batchArr: [],
      groupOneSelection: [],
      groupTwoSelection: [],
      batchObj: null,
      batchFilter: '%%',
      transferType: 'manual',
      transferData: '',
      makeTransferDialog: false,
      selectAll: false,
      counts: { product: 0, productLine: 0, inventory: 200 },
      slide: 'style',
      invoiceNumber: '',
      invoiceNote: '',
      invoiceDate: moment(),
      menuId: 0,
      selectedOrgObj: '',
      fullScreenImageDialog: false,
      imageIndex: 0,
      fullScreenImageArr: [],
      InventoryItemsDialog: false,
      preferredDistributorsList: [],
      uploadFileDialog: false,
      fileToUpload: '',
    }
  },
  watch: {
    makeTransferDialog () {
      this.batchArr = ''
      this.batchFilter = '%%'
      this.batchObj = null
    },
    selectAll () {
      if (this.selectAll) {
        this.groupOneSelection = []
        this.batchArr.forEach(batch => {
          this.groupOneSelection.push(batch)
        })
      } else {
        this.groupOneSelection = []
      }
    },
  },
  mounted () {
    this.menuId = this.menu_id ? this.menu_id : 0
  },
}
</script>

<style lang="scss" scoped>
.card {
  /*text-align: center;*/
  width: 100%;
  /*padding: 30px 40px;*/
  /*margin: auto;*/
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: bottom;
  border-radius: 4px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
  position: relative;
}

span {
  color: #3e4c4c;
  text-align: left;
  font-size: large;
}

.bankDetail {
  background-image: url("../../../src/assets/card.png");
  background-repeat: no-repeat;
  background-position: top right;
}


</style>
